export const BEST_TIME_TO_POST_PERIOD = {
  metric: {
    key: 'bestTimeToPost',
    title: 'pagePerformance.metricProperties.fb.bestTimeToPost',
    queryParameter: 'best_time_to_post',
  },
  metricData: {
    metricCardProperties: {
      sliceLimit: 24,
      graphType: 'heatmap',
      withoutGeneralLabels: true,
      description:
        'See when your post got the most attention, based on current period selection.',
      graphLabels: {},
      generalDataLabels: {},
    },
    metricGraphData: [
      {
        key: 'Post_impressions',
        label: '',
        legendLabels: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        graphValues: {
          data: [
            {
              value: 0,
              date: '0',
              secondValue: 0.0001,
            },
            {
              value: 0,
              date: '1',
              secondValue: 0.0001,
            },
            {
              value: 0.0004,
              date: '2',
              secondValue: 0.0004,
            },
            {
              value: 0.0016,
              date: '3',
              secondValue: 0.0016,
            },
            {
              value: 0.0045,
              date: '4',
              secondValue: 0.0044,
            },
            {
              value: 0.0093,
              date: '5',
              secondValue: 0.0091,
            },
            {
              value: 0.0153,
              date: '6',
              secondValue: 0.015,
            },
            {
              value: 0.0207,
              date: '7',
              secondValue: 0.0203,
            },
            {
              value: 0.0232,
              date: '8',
              secondValue: 1,
            },
            {
              value: 0.0221,
              date: '9',
              secondValue: 0.9992,
            },
            {
              value: 0.0191,
              date: '10',
              secondValue: 0.9967,
            },
            {
              value: 0.0153,
              date: '11',
              secondValue: 0.9932,
            },
            {
              value: 0.0112,
              date: '12',
              secondValue: 0.9892,
            },
            {
              value: 0.0081,
              date: '13',
              secondValue: 0.0088,
            },
            {
              value: 0.0064,
              date: '14',
              secondValue: 0.0074,
            },
            {
              value: 0.0052,
              date: '15',
              secondValue: 0.0063,
            },
            {
              value: 0.0038,
              date: '16',
              secondValue: 0.0046,
            },
            {
              value: 0.0025,
              date: '17',
              secondValue: 0.0029,
            },
            {
              value: 0.0016,
              date: '18',
              secondValue: 0.0017,
            },
            {
              value: 0.0009,
              date: '19',
              secondValue: 0.0009,
            },
            {
              value: 0.0004,
              date: '20',
              secondValue: 0.0003,
            },
            {
              value: 0.0001,
              date: '21',
              secondValue: 0.0001,
            },
            {
              value: 0.0001,
              date: '22',
              secondValue: 0.0001,
            },
            {
              value: 0.0001,
              date: '23',
              secondValue: 0.0001,
            },
          ],
          gridData: [
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0,
                date: '1',
              },
              {
                value: 0.0004,
                date: '2',
              },
              {
                value: 0.0016,
                date: '3',
              },
              {
                value: 0.0045,
                date: '4',
              },
              {
                value: 0.0093,
                date: '5',
              },
              {
                value: 0.0153,
                date: '6',
              },
              {
                value: 0.0207,
                date: '7',
              },
              {
                value: 0.0232,
                date: '8',
              },
              {
                value: 0.0221,
                date: '9',
              },
              {
                value: 0.0191,
                date: '10',
              },
              {
                value: 0.0153,
                date: '11',
              },
              {
                value: 0.0112,
                date: '12',
              },
              {
                value: 0.0081,
                date: '13',
              },
              {
                value: 0.0064,
                date: '14',
              },
              {
                value: 0.0052,
                date: '15',
              },
              {
                value: 0.0038,
                date: '16',
              },
              {
                value: 0.0025,
                date: '17',
              },
              {
                value: 0.0016,
                date: '18',
              },
              {
                value: 0.0009,
                date: '19',
              },
              {
                value: 0.0004,
                date: '20',
              },
              {
                value: 0.0001,
                date: '21',
              },
              {
                value: 0.0001,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0.0001,
                date: '0',
              },
              {
                value: 0.0001,
                date: '1',
              },
              {
                value: 0.0004,
                date: '2',
              },
              {
                value: 0.0016,
                date: '3',
              },
              {
                value: 0.0044,
                date: '4',
              },
              {
                value: 0.0091,
                date: '5',
              },
              {
                value: 0.015,
                date: '6',
              },
              {
                value: 0.0203,
                date: '7',
              },
              {
                value: 1,
                date: '8',
              },
              {
                value: 0.9992,
                date: '9',
              },
              {
                value: 0.9967,
                date: '10',
              },
              {
                value: 0.9932,
                date: '11',
              },
              {
                value: 0.9892,
                date: '12',
              },
              {
                value: 0.0088,
                date: '13',
              },
              {
                value: 0.0074,
                date: '14',
              },
              {
                value: 0.0063,
                date: '15',
              },
              {
                value: 0.0046,
                date: '16',
              },
              {
                value: 0.0029,
                date: '17',
              },
              {
                value: 0.0017,
                date: '18',
              },
              {
                value: 0.0009,
                date: '19',
              },
              {
                value: 0.0003,
                date: '20',
              },
              {
                value: 0.0001,
                date: '21',
              },
              {
                value: 0.0001,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0.0001,
                date: '0',
              },
              {
                value: 0.0001,
                date: '1',
              },
              {
                value: 0.0004,
                date: '2',
              },
              {
                value: 0.0016,
                date: '3',
              },
              {
                value: 0.0044,
                date: '4',
              },
              {
                value: 0.009,
                date: '5',
              },
              {
                value: 0.0147,
                date: '6',
              },
              {
                value: 0.0198,
                date: '7',
              },
              {
                value: 0.0223,
                date: '8',
              },
              {
                value: 0.0221,
                date: '9',
              },
              {
                value: 0.02,
                date: '10',
              },
              {
                value: 0.0167,
                date: '11',
              },
              {
                value: 0.0126,
                date: '12',
              },
              {
                value: 0.0095,
                date: '13',
              },
              {
                value: 0.0081,
                date: '14',
              },
              {
                value: 0.007,
                date: '15',
              },
              {
                value: 0.0051,
                date: '16',
              },
              {
                value: 0.0031,
                date: '17',
              },
              {
                value: 0.0016,
                date: '18',
              },
              {
                value: 0.0008,
                date: '19',
              },
              {
                value: 0.0003,
                date: '20',
              },
              {
                value: 0.0001,
                date: '21',
              },
              {
                value: 0.0001,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0.0001,
                date: '0',
              },
              {
                value: 0,
                date: '1',
              },
              {
                value: 0.0003,
                date: '2',
              },
              {
                value: 0.0015,
                date: '3',
              },
              {
                value: 0.0043,
                date: '4',
              },
              {
                value: 0.0086,
                date: '5',
              },
              {
                value: 0.0137,
                date: '6',
              },
              {
                value: 0.0182,
                date: '7',
              },
              {
                value: 0.9982,
                date: '8',
              },
              {
                value: 0.9987,
                date: '9',
              },
              {
                value: 0.9972,
                date: '10',
              },
              {
                value: 0.9941,
                date: '11',
              },
              {
                value: 0.9901,
                date: '12',
              },
              {
                value: 0.0097,
                date: '13',
              },
              {
                value: 0.0082,
                date: '14',
              },
              {
                value: 0.0071,
                date: '15',
              },
              {
                value: 0.0051,
                date: '16',
              },
              {
                value: 0.0029,
                date: '17',
              },
              {
                value: 0.0014,
                date: '18',
              },
              {
                value: 0.0006,
                date: '19',
              },
              {
                value: 0.0002,
                date: '20',
              },
              {
                value: 0.0001,
                date: '21',
              },
              {
                value: 0.0001,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0,
                date: '1',
              },
              {
                value: 0.0004,
                date: '2',
              },
              {
                value: 0.0016,
                date: '3',
              },
              {
                value: 0.0044,
                date: '4',
              },
              {
                value: 0.0087,
                date: '5',
              },
              {
                value: 0.0137,
                date: '6',
              },
              {
                value: 0.0181,
                date: '7',
              },
              {
                value: 0.0208,
                date: '8',
              },
              {
                value: 0.0213,
                date: '9',
              },
              {
                value: 0.0199,
                date: '10',
              },
              {
                value: 0.0168,
                date: '11',
              },
              {
                value: 0.0127,
                date: '12',
              },
              {
                value: 0.0095,
                date: '13',
              },
              {
                value: 0.0079,
                date: '14',
              },
              {
                value: 0.0067,
                date: '15',
              },
              {
                value: 0.0048,
                date: '16',
              },
              {
                value: 0.0027,
                date: '17',
              },
              {
                value: 0.0013,
                date: '18',
              },
              {
                value: 0.0006,
                date: '19',
              },
              {
                value: 0.0002,
                date: '20',
              },
              {
                value: 0,
                date: '21',
              },
              {
                value: 0,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0,
                date: '1',
              },
              {
                value: 0.0004,
                date: '2',
              },
              {
                value: 0.0017,
                date: '3',
              },
              {
                value: 0.0047,
                date: '4',
              },
              {
                value: 0.0093,
                date: '5',
              },
              {
                value: 0.0148,
                date: '6',
              },
              {
                value: 0.0198,
                date: '7',
              },
              {
                value: 0.0225,
                date: '8',
              },
              {
                value: 0.0224,
                date: '9',
              },
              {
                value: 0.0203,
                date: '10',
              },
              {
                value: 0.0167,
                date: '11',
              },
              {
                value: 0.0124,
                date: '12',
              },
              {
                value: 0.009,
                date: '13',
              },
              {
                value: 0.0072,
                date: '14',
              },
              {
                value: 0.0059,
                date: '15',
              },
              {
                value: 0.0042,
                date: '16',
              },
              {
                value: 0.0025,
                date: '17',
              },
              {
                value: 0.0014,
                date: '18',
              },
              {
                value: 0.0007,
                date: '19',
              },
              {
                value: 0.0003,
                date: '20',
              },
              {
                value: 0,
                date: '21',
              },
              {
                value: 0,
                date: '22',
              },
              {
                value: 0,
                date: '23',
              },
            ],
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0,
                date: '1',
              },
              {
                value: 0.0004,
                date: '2',
              },
              {
                value: 0.0017,
                date: '3',
              },
              {
                value: 0.0047,
                date: '4',
              },
              {
                value: 0.0096,
                date: '5',
              },
              {
                value: 0.0155,
                date: '6',
              },
              {
                value: 0.0209,
                date: '7',
              },
              {
                value: 0.0235,
                date: '8',
              },
              {
                value: 0.0227,
                date: '9',
              },
              {
                value: 0.0199,
                date: '10',
              },
              {
                value: 0.016,
                date: '11',
              },
              {
                value: 0.0117,
                date: '12',
              },
              {
                value: 0.0082,
                date: '13',
              },
              {
                value: 0.0063,
                date: '14',
              },
              {
                value: 0.0051,
                date: '15',
              },
              {
                value: 0.0037,
                date: '16',
              },
              {
                value: 0.0023,
                date: '17',
              },
              {
                value: 0.0014,
                date: '18',
              },
              {
                value: 0.0008,
                date: '19',
              },
              {
                value: 0.0003,
                date: '20',
              },
              {
                value: 0.0001,
                date: '21',
              },
              {
                value: 0,
                date: '22',
              },
              {
                value: 0,
                date: '23',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '216',
        metricKey: 'total',
        label: '',
      },
    ],
    isCombinedMetric: true,
  },
};

export const BEST_TIME_TO_POST_ALL = {
  metric: {
    key: 'bestTimeToPostAllTime',
    title: 'pagePerformance.metricProperties.fb.bestTimeToPostAllTime',
    queryParameter: 'best_time_to_post',
  },
  metricData: {
    metricCardProperties: {
      sliceLimit: 24,
      graphType: 'heatmap',
      withoutGeneralLabels: true,
      description:
        'See when your post got the most attention, based on the last 2 years.',
      graphLabels: {},
      generalDataLabels: {},
    },
    metricGraphData: [
      {
        key: 'Post_impressions',
        label: '',
        legendLabels: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        graphValues: {
          data: [
            {
              value: 0,
              date: '0',
              secondValue: 0,
            },
            {
              value: 0.0001,
              date: '1',
              secondValue: 0.0001,
            },
            {
              value: 0.0008,
              date: '2',
              secondValue: 0.0006,
            },
            {
              value: 0.0036,
              date: '3',
              secondValue: 0.003,
            },
            {
              value: 0.0106,
              date: '4',
              secondValue: 0.0088,
            },
            {
              value: 0.0216,
              date: '5',
              secondValue: 0.018,
            },
            {
              value: 0.0306,
              date: '6',
              secondValue: 0.026,
            },
            {
              value: 0.0321,
              date: '7',
              secondValue: 0.0281,
            },
            {
              value: 0.0271,
              date: '8',
              secondValue: 0.9992,
            },
            {
              value: 0.0211,
              date: '9',
              secondValue: 0.9946,
            },
            {
              value: 0.0175,
              date: '10',
              secondValue: 0.9916,
            },
            {
              value: 0.0158,
              date: '11',
              secondValue: 0.9901,
            },
            {
              value: 0.014,
              date: '12',
              secondValue: 0.9883,
            },
            {
              value: 0.0114,
              date: '13',
              secondValue: 0.0115,
            },
            {
              value: 0.0086,
              date: '14',
              secondValue: 0.0091,
            },
            {
              value: 0.0064,
              date: '15',
              secondValue: 0.0071,
            },
            {
              value: 0.0054,
              date: '16',
              secondValue: 0.006,
            },
            {
              value: 0.0056,
              date: '17',
              secondValue: 0.0061,
            },
            {
              value: 0.0056,
              date: '18',
              secondValue: 0.006,
            },
            {
              value: 0.0042,
              date: '19',
              secondValue: 0.0044,
            },
            {
              value: 0.0021,
              date: '20',
              secondValue: 0.0022,
            },
            {
              value: 0.0007,
              date: '21',
              secondValue: 0.0007,
            },
            {
              value: 0.0002,
              date: '22',
              secondValue: 0.0002,
            },
            {
              value: 0.0001,
              date: '23',
              secondValue: 0.0001,
            },
          ],
          gridData: [
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0.0001,
                date: '1',
              },
              {
                value: 0.0008,
                date: '2',
              },
              {
                value: 0.0036,
                date: '3',
              },
              {
                value: 0.0106,
                date: '4',
              },
              {
                value: 0.0216,
                date: '5',
              },
              {
                value: 0.0306,
                date: '6',
              },
              {
                value: 0.0321,
                date: '7',
              },
              {
                value: 0.0271,
                date: '8',
              },
              {
                value: 0.0211,
                date: '9',
              },
              {
                value: 0.0175,
                date: '10',
              },
              {
                value: 0.0158,
                date: '11',
              },
              {
                value: 0.014,
                date: '12',
              },
              {
                value: 0.0114,
                date: '13',
              },
              {
                value: 0.0086,
                date: '14',
              },
              {
                value: 0.0064,
                date: '15',
              },
              {
                value: 0.0054,
                date: '16',
              },
              {
                value: 0.0056,
                date: '17',
              },
              {
                value: 0.0056,
                date: '18',
              },
              {
                value: 0.0042,
                date: '19',
              },
              {
                value: 0.0021,
                date: '20',
              },
              {
                value: 0.0007,
                date: '21',
              },
              {
                value: 0.0002,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0.0001,
                date: '1',
              },
              {
                value: 0.0006,
                date: '2',
              },
              {
                value: 0.003,
                date: '3',
              },
              {
                value: 0.0088,
                date: '4',
              },
              {
                value: 0.018,
                date: '5',
              },
              {
                value: 0.026,
                date: '6',
              },
              {
                value: 0.0281,
                date: '7',
              },
              {
                value: 0.9992,
                date: '8',
              },
              {
                value: 0.9946,
                date: '9',
              },
              {
                value: 0.9916,
                date: '10',
              },
              {
                value: 0.9901,
                date: '11',
              },
              {
                value: 0.9883,
                date: '12',
              },
              {
                value: 0.0115,
                date: '13',
              },
              {
                value: 0.0091,
                date: '14',
              },
              {
                value: 0.0071,
                date: '15',
              },
              {
                value: 0.006,
                date: '16',
              },
              {
                value: 0.0061,
                date: '17',
              },
              {
                value: 0.006,
                date: '18',
              },
              {
                value: 0.0044,
                date: '19',
              },
              {
                value: 0.0022,
                date: '20',
              },
              {
                value: 0.0007,
                date: '21',
              },
              {
                value: 0.0002,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0.0001,
                date: '0',
              },
              {
                value: 0.0001,
                date: '1',
              },
              {
                value: 0.0006,
                date: '2',
              },
              {
                value: 0.003,
                date: '3',
              },
              {
                value: 0.0088,
                date: '4',
              },
              {
                value: 0.018,
                date: '5',
              },
              {
                value: 0.0258,
                date: '6',
              },
              {
                value: 0.0278,
                date: '7',
              },
              {
                value: 0.0245,
                date: '8',
              },
              {
                value: 0.0202,
                date: '9',
              },
              {
                value: 0.0176,
                date: '10',
              },
              {
                value: 0.016,
                date: '11',
              },
              {
                value: 0.014,
                date: '12',
              },
              {
                value: 0.0116,
                date: '13',
              },
              {
                value: 0.0093,
                date: '14',
              },
              {
                value: 0.0074,
                date: '15',
              },
              {
                value: 0.0062,
                date: '16',
              },
              {
                value: 0.006,
                date: '17',
              },
              {
                value: 0.0057,
                date: '18',
              },
              {
                value: 0.0041,
                date: '19',
              },
              {
                value: 0.002,
                date: '20',
              },
              {
                value: 0.0007,
                date: '21',
              },
              {
                value: 0.0002,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0.0001,
                date: '1',
              },
              {
                value: 0.0007,
                date: '2',
              },
              {
                value: 0.0035,
                date: '3',
              },
              {
                value: 0.0105,
                date: '4',
              },
              {
                value: 0.0211,
                date: '5',
              },
              {
                value: 0.0295,
                date: '6',
              },
              {
                value: 0.0303,
                date: '7',
              },
              {
                value: 1,
                date: '8',
              },
              {
                value: 0.995,
                date: '9',
              },
              {
                value: 0.9923,
                date: '10',
              },
              {
                value: 0.9907,
                date: '11',
              },
              {
                value: 0.9886,
                date: '12',
              },
              {
                value: 0.0115,
                date: '13',
              },
              {
                value: 0.0091,
                date: '14',
              },
              {
                value: 0.0072,
                date: '15',
              },
              {
                value: 0.0059,
                date: '16',
              },
              {
                value: 0.0053,
                date: '17',
              },
              {
                value: 0.0048,
                date: '18',
              },
              {
                value: 0.0035,
                date: '19',
              },
              {
                value: 0.0017,
                date: '20',
              },
              {
                value: 0.0005,
                date: '21',
              },
              {
                value: 0.0001,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0.0001,
                date: '1',
              },
              {
                value: 0.0008,
                date: '2',
              },
              {
                value: 0.004,
                date: '3',
              },
              {
                value: 0.0118,
                date: '4',
              },
              {
                value: 0.0237,
                date: '5',
              },
              {
                value: 0.0327,
                date: '6',
              },
              {
                value: 0.033,
                date: '7',
              },
              {
                value: 0.027,
                date: '8',
              },
              {
                value: 0.0211,
                date: '9',
              },
              {
                value: 0.0182,
                date: '10',
              },
              {
                value: 0.0166,
                date: '11',
              },
              {
                value: 0.0144,
                date: '12',
              },
              {
                value: 0.0115,
                date: '13',
              },
              {
                value: 0.0089,
                date: '14',
              },
              {
                value: 0.0068,
                date: '15',
              },
              {
                value: 0.0053,
                date: '16',
              },
              {
                value: 0.0045,
                date: '17',
              },
              {
                value: 0.0039,
                date: '18',
              },
              {
                value: 0.0027,
                date: '19',
              },
              {
                value: 0.0013,
                date: '20',
              },
              {
                value: 0.0004,
                date: '21',
              },
              {
                value: 0.0001,
                date: '22',
              },
              {
                value: 0.0001,
                date: '23',
              },
            ],
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0.0001,
                date: '1',
              },
              {
                value: 0.0009,
                date: '2',
              },
              {
                value: 0.0042,
                date: '3',
              },
              {
                value: 0.0125,
                date: '4',
              },
              {
                value: 0.0251,
                date: '5',
              },
              {
                value: 0.0348,
                date: '6',
              },
              {
                value: 0.0352,
                date: '7',
              },
              {
                value: 0.0288,
                date: '8',
              },
              {
                value: 0.0222,
                date: '9',
              },
              {
                value: 0.0187,
                date: '10',
              },
              {
                value: 0.017,
                date: '11',
              },
              {
                value: 0.0148,
                date: '12',
              },
              {
                value: 0.0119,
                date: '13',
              },
              {
                value: 0.0089,
                date: '14',
              },
              {
                value: 0.0065,
                date: '15',
              },
              {
                value: 0.0049,
                date: '16',
              },
              {
                value: 0.0043,
                date: '17',
              },
              {
                value: 0.0039,
                date: '18',
              },
              {
                value: 0.0028,
                date: '19',
              },
              {
                value: 0.0014,
                date: '20',
              },
              {
                value: 0.0004,
                date: '21',
              },
              {
                value: 0.0001,
                date: '22',
              },
              {
                value: 0,
                date: '23',
              },
            ],
            [
              {
                value: 0,
                date: '0',
              },
              {
                value: 0.0001,
                date: '1',
              },
              {
                value: 0.0009,
                date: '2',
              },
              {
                value: 0.0041,
                date: '3',
              },
              {
                value: 0.0121,
                date: '4',
              },
              {
                value: 0.0243,
                date: '5',
              },
              {
                value: 0.0341,
                date: '6',
              },
              {
                value: 0.035,
                date: '7',
              },
              {
                value: 0.0289,
                date: '8',
              },
              {
                value: 0.0222,
                date: '9',
              },
              {
                value: 0.0184,
                date: '10',
              },
              {
                value: 0.0165,
                date: '11',
              },
              {
                value: 0.0145,
                date: '12',
              },
              {
                value: 0.0116,
                date: '13',
              },
              {
                value: 0.0085,
                date: '14',
              },
              {
                value: 0.0061,
                date: '15',
              },
              {
                value: 0.0049,
                date: '16',
              },
              {
                value: 0.0049,
                date: '17',
              },
              {
                value: 0.0049,
                date: '18',
              },
              {
                value: 0.0036,
                date: '19',
              },
              {
                value: 0.0018,
                date: '20',
              },
              {
                value: 0.0005,
                date: '21',
              },
              {
                value: 0.0001,
                date: '22',
              },
              {
                value: 0,
                date: '23',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '1.17K',
        metricKey: 'total',
        label: '',
      },
    ],
    isCombinedMetric: true,
  },
};

export const IMPRESSIONS = {
  metric: {
    key: 'page_impressions',
    title: 'pagePerformance.metricProperties.common.impressions',
    queryParameter: 'page_impressions',
  },
  metricData: {
    metricCardProperties: {
      graphType: 'area',
      generalDataLabels: {
        total: 'Total',
        daily_average: 'Daily average',
      },
    },
    metricGraphData: [
      {
        key: 'total',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 37,
              date: '2024-01-01',
            },
            {
              value: 65,
              date: '2024-01-31',
            },
            {
              value: 29,
              date: '2024-03-01',
            },
            {
              value: 75,
              date: '2024-03-31',
            },
            {
              value: 198,
              date: '2024-04-30',
            },
            {
              value: 160,
              date: '2024-05-30',
            },
            {
              value: 1465,
              date: '2024-06-29',
            },
            {
              value: 443,
              date: '2024-07-29',
            },
            {
              value: 35,
              date: '2024-08-28',
            },
            {
              value: 141,
              date: '2024-09-27',
            },
            {
              value: 68,
              date: '2024-10-27',
            },
            {
              value: 88,
              date: '2024-11-26',
            },
            {
              value: 3,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 37,
                date: '2024-01-01',
              },
              {
                value: 65,
                date: '2024-01-31',
              },
              {
                value: 29,
                date: '2024-03-01',
              },
              {
                value: 75,
                date: '2024-03-31',
              },
              {
                value: 198,
                date: '2024-04-30',
              },
              {
                value: 160,
                date: '2024-05-30',
              },
              {
                value: 1465,
                date: '2024-06-29',
              },
              {
                value: 443,
                date: '2024-07-29',
              },
              {
                value: 35,
                date: '2024-08-28',
              },
              {
                value: 141,
                date: '2024-09-27',
              },
              {
                value: 68,
                date: '2024-10-27',
              },
              {
                value: 88,
                date: '2024-11-26',
              },
              {
                value: 3,
                date: '2024-12-26',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '2.81K',
        metricKey: 'total',
        label: 'Total',
      },
      {
        value: '7.67',
        metricKey: 'daily_average',
        label: 'Daily average',
      },
    ],
    isCombinedMetric: false,
  },
};

export const PAID_VS_ORGANIC = {
  metric: {
    key: 'paid_vs_organic_unique',
    title: 'pagePerformance.metricProperties.fb.paidUniqueVsOrganicUnique',
    queryParameter: 'paid_vs_organic_unique',
  },
  metricData: {
    metricCardProperties: {
      graphType: 'area',
      alternativeGraphType: 'bar',
      generalDataLabels: {
        total: 'Total',
        daily_average: 'Daily average',
        paid: 'Paid unique',
        organic: 'Organic unique',
      },
    },
    metricGraphData: [
      {
        key: 'paid_vs_organic',
        label: '',
        legendLabels: ['paid', 'organic'],
        graphValues: {
          data: [
            {
              value: 0,
              date: '2024-01-01',
              secondValue: 25,
            },
            {
              value: 0,
              date: '2024-01-31',
              secondValue: 28,
            },
            {
              value: 0,
              date: '2024-03-01',
              secondValue: 18,
            },
            {
              value: 0,
              date: '2024-03-31',
              secondValue: 21,
            },
            {
              value: 0,
              date: '2024-04-30',
              secondValue: 161,
            },
            {
              value: 0,
              date: '2024-05-30',
              secondValue: 103,
            },
            {
              value: 0,
              date: '2024-06-29',
              secondValue: 1269,
            },
            {
              value: 0,
              date: '2024-07-29',
              secondValue: 362,
            },
            {
              value: 0,
              date: '2024-08-28',
            },
            {
              value: 0,
              date: '2024-09-27',
            },
            {
              value: 0,
              date: '2024-10-27',
            },
            {
              value: 0,
              date: '2024-11-26',
            },
            {
              value: 0,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 0,
                date: '2024-01-01',
              },
              {
                value: 0,
                date: '2024-01-31',
              },
              {
                value: 0,
                date: '2024-03-01',
              },
              {
                value: 0,
                date: '2024-03-31',
              },
              {
                value: 0,
                date: '2024-04-30',
              },
              {
                value: 0,
                date: '2024-05-30',
              },
              {
                value: 0,
                date: '2024-06-29',
              },
              {
                value: 0,
                date: '2024-07-29',
              },
              {
                value: 0,
                date: '2024-08-28',
              },
              {
                value: 0,
                date: '2024-09-27',
              },
              {
                value: 0,
                date: '2024-10-27',
              },
              {
                value: 0,
                date: '2024-11-26',
              },
              {
                value: 0,
                date: '2024-12-26',
              },
            ],
            [
              {
                value: 25,
                date: '2024-01-01',
              },
              {
                value: 28,
                date: '2024-01-31',
              },
              {
                value: 18,
                date: '2024-03-01',
              },
              {
                value: 21,
                date: '2024-03-31',
              },
              {
                value: 161,
                date: '2024-04-30',
              },
              {
                value: 103,
                date: '2024-05-30',
              },
              {
                value: 1269,
                date: '2024-06-29',
              },
              {
                value: 362,
                date: '2024-07-29',
              },
            ],
          ],
        },
      },
      {
        key: 'paid',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 0,
              date: '2024-01-01',
            },
            {
              value: 0,
              date: '2024-01-31',
            },
            {
              value: 0,
              date: '2024-03-01',
            },
            {
              value: 0,
              date: '2024-03-31',
            },
            {
              value: 0,
              date: '2024-04-30',
            },
            {
              value: 0,
              date: '2024-05-30',
            },
            {
              value: 0,
              date: '2024-06-29',
            },
            {
              value: 0,
              date: '2024-07-29',
            },
            {
              value: 0,
              date: '2024-08-28',
            },
            {
              value: 0,
              date: '2024-09-27',
            },
            {
              value: 0,
              date: '2024-10-27',
            },
            {
              value: 0,
              date: '2024-11-26',
            },
            {
              value: 0,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 0,
                date: '2024-01-01',
              },
              {
                value: 0,
                date: '2024-01-31',
              },
              {
                value: 0,
                date: '2024-03-01',
              },
              {
                value: 0,
                date: '2024-03-31',
              },
              {
                value: 0,
                date: '2024-04-30',
              },
              {
                value: 0,
                date: '2024-05-30',
              },
              {
                value: 0,
                date: '2024-06-29',
              },
              {
                value: 0,
                date: '2024-07-29',
              },
              {
                value: 0,
                date: '2024-08-28',
              },
              {
                value: 0,
                date: '2024-09-27',
              },
              {
                value: 0,
                date: '2024-10-27',
              },
              {
                value: 0,
                date: '2024-11-26',
              },
              {
                value: 0,
                date: '2024-12-26',
              },
            ],
          ],
        },
      },
      {
        key: 'organic',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 25,
              date: '2024-01-01',
            },
            {
              value: 28,
              date: '2024-01-31',
            },
            {
              value: 18,
              date: '2024-03-01',
            },
            {
              value: 21,
              date: '2024-03-31',
            },
            {
              value: 161,
              date: '2024-04-30',
            },
            {
              value: 103,
              date: '2024-05-30',
            },
            {
              value: 1269,
              date: '2024-06-29',
            },
            {
              value: 362,
              date: '2024-07-29',
            },
          ],
          gridData: [
            [
              {
                value: 25,
                date: '2024-01-01',
              },
              {
                value: 28,
                date: '2024-01-31',
              },
              {
                value: 18,
                date: '2024-03-01',
              },
              {
                value: 21,
                date: '2024-03-31',
              },
              {
                value: 161,
                date: '2024-04-30',
              },
              {
                value: 103,
                date: '2024-05-30',
              },
              {
                value: 1269,
                date: '2024-06-29',
              },
              {
                value: 362,
                date: '2024-07-29',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '1.99K',
        metricKey: 'total',
        label: 'Total',
      },
      {
        value: '8.28',
        metricKey: 'daily_average',
        label: 'Daily average',
      },
      {
        value: '0',
        metricKey: 'paid',
        label: 'Paid unique',
      },
      {
        value: '1.99K',
        metricKey: 'organic',
        label: 'Organic unique',
      },
    ],
    isCombinedMetric: true,
  },
};

export const UNIQUE_IMPRESSIONS = {
  metric: {
    key: 'page_unique_impressions',
    title: 'pagePerformance.metricProperties.fb.uniqueImpressions',
    queryParameter: 'page_unique_impressions',
  },
  metricData: {
    metricCardProperties: {
      graphType: 'area',
      generalDataLabels: {
        total: 'Total',
        daily_average: 'Daily average',
      },
    },
    metricGraphData: [
      {
        key: 'total',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 26,
              date: '2024-01-01',
            },
            {
              value: 28,
              date: '2024-01-31',
            },
            {
              value: 18,
              date: '2024-03-01',
            },
            {
              value: 21,
              date: '2024-03-31',
            },
            {
              value: 162,
              date: '2024-04-30',
            },
            {
              value: 104,
              date: '2024-05-30',
            },
            {
              value: 1271,
              date: '2024-06-29',
            },
            {
              value: 362,
              date: '2024-07-29',
            },
            {
              value: 29,
              date: '2024-08-28',
            },
            {
              value: 107,
              date: '2024-09-27',
            },
            {
              value: 49,
              date: '2024-10-27',
            },
            {
              value: 79,
              date: '2024-11-26',
            },
            {
              value: 3,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 26,
                date: '2024-01-01',
              },
              {
                value: 28,
                date: '2024-01-31',
              },
              {
                value: 18,
                date: '2024-03-01',
              },
              {
                value: 21,
                date: '2024-03-31',
              },
              {
                value: 162,
                date: '2024-04-30',
              },
              {
                value: 104,
                date: '2024-05-30',
              },
              {
                value: 1271,
                date: '2024-06-29',
              },
              {
                value: 362,
                date: '2024-07-29',
              },
              {
                value: 29,
                date: '2024-08-28',
              },
              {
                value: 107,
                date: '2024-09-27',
              },
              {
                value: 49,
                date: '2024-10-27',
              },
              {
                value: 79,
                date: '2024-11-26',
              },
              {
                value: 3,
                date: '2024-12-26',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '2.26K',
        metricKey: 'total',
        label: 'Total',
      },
      {
        value: '6.17',
        metricKey: 'daily_average',
        label: 'Daily average',
      },
    ],
    isCombinedMetric: false,
  },
};

export const POST_ENGAGEMENT = {
  metric: {
    key: 'post_engagement',
    title: 'pagePerformance.metricProperties.fb.postEngagements',
    queryParameter: 'post_engagement',
  },
  metricData: {
    metricCardProperties: {
      graphType: 'area',
      generalDataLabels: {
        total: 'Total',
        daily_average: 'Daily average',
      },
    },
    metricGraphData: [
      {
        key: 'total',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 32,
              date: '2024-01-01',
            },
            {
              value: 153,
              date: '2024-01-31',
            },
            {
              value: 221,
              date: '2024-03-01',
            },
            {
              value: 184,
              date: '2024-03-31',
            },
            {
              value: 137,
              date: '2024-04-30',
            },
            {
              value: 280,
              date: '2024-05-30',
            },
            {
              value: 119,
              date: '2024-06-29',
            },
            {
              value: 83,
              date: '2024-07-29',
            },
            {
              value: 73,
              date: '2024-08-28',
            },
            {
              value: 157,
              date: '2024-09-27',
            },
            {
              value: 224,
              date: '2024-10-27',
            },
            {
              value: 141,
              date: '2024-11-26',
            },
            {
              value: 1,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 32,
                date: '2024-01-01',
              },
              {
                value: 153,
                date: '2024-01-31',
              },
              {
                value: 221,
                date: '2024-03-01',
              },
              {
                value: 184,
                date: '2024-03-31',
              },
              {
                value: 137,
                date: '2024-04-30',
              },
              {
                value: 280,
                date: '2024-05-30',
              },
              {
                value: 119,
                date: '2024-06-29',
              },
              {
                value: 83,
                date: '2024-07-29',
              },
              {
                value: 73,
                date: '2024-08-28',
              },
              {
                value: 157,
                date: '2024-09-27',
              },
              {
                value: 224,
                date: '2024-10-27',
              },
              {
                value: 141,
                date: '2024-11-26',
              },
              {
                value: 1,
                date: '2024-12-26',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '1.81K',
        metricKey: 'total',
        label: 'Total',
      },
      {
        value: '4.93',
        metricKey: 'daily_average',
        label: 'Daily average',
      },
    ],
    isCombinedMetric: false,
  },
};

export const ENGAGEMENT_RATE = {
  metric: {
    key: 'engagement',
    title: 'pagePerformance.metricProperties.common.engagement',
    queryParameter: 'page_engagement_rate',
  },
  metricData: {
    metricCardProperties: {
      graphType: 'area',
      generalDataLabels: {
        total: 'Total',
        daily_average: 'Daily average',
      },
    },
    metricGraphData: [
      {
        key: 'total',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 0,
              date: '2024-01-01',
            },
            {
              value: 0.42,
              date: '2024-01-31',
            },
            {
              value: 1.67,
              date: '2024-03-01',
            },
            {
              value: 4.44,
              date: '2024-03-31',
            },
            {
              value: 2.5,
              date: '2024-04-30',
            },
            {
              value: 2.78,
              date: '2024-05-30',
            },
            {
              value: 4.44,
              date: '2024-06-29',
            },
            {
              value: 1.67,
              date: '2024-07-29',
            },
            {
              value: 7.47,
              date: '2024-08-28',
            },
            {
              value: 0,
              date: '2024-09-27',
            },
            {
              value: 4.59,
              date: '2024-10-27',
            },
            {
              value: 0.07,
              date: '2024-11-26',
            },
            {
              value: 0,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 0,
                date: '2024-01-01',
              },
              {
                value: 0.42,
                date: '2024-01-31',
              },
              {
                value: 1.67,
                date: '2024-03-01',
              },
              {
                value: 4.44,
                date: '2024-03-31',
              },
              {
                value: 2.5,
                date: '2024-04-30',
              },
              {
                value: 2.78,
                date: '2024-05-30',
              },
              {
                value: 4.44,
                date: '2024-06-29',
              },
              {
                value: 1.67,
                date: '2024-07-29',
              },
              {
                value: 7.47,
                date: '2024-08-28',
              },
              {
                value: 0,
                date: '2024-09-27',
              },
              {
                value: 4.59,
                date: '2024-10-27',
              },
              {
                value: 0.07,
                date: '2024-11-26',
              },
              {
                value: 0,
                date: '2024-12-26',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '1.88%',
        metricKey: 'total',
        label: 'Total',
      },
    ],
    isCombinedMetric: false,
  },
};

export const VIRAL_VS_NON_VIRAL = {
  metric: {
    key: 'viral_vs_nonviral_unique',
    title: 'pagePerformance.metricProperties.fb.viralUniqueVsNonviralUnique',
    queryParameter: 'viral_vs_nonviral_unique',
  },
  metricData: {
    metricCardProperties: {
      graphType: 'area',
      alternativeGraphType: 'bar',
      generalDataLabels: {
        total: 'Total',
        daily_average: 'Daily average',
        viral: 'Viral unique',
        nonviral: 'Nonviral unique',
      },
    },
    metricGraphData: [
      {
        key: 'viral_vs_nonviral',
        label: '',
        legendLabels: ['viral', 'nonviral'],
        graphValues: {
          data: [
            {
              value: 0,
              date: '2025-01-01',
              secondValue: 677,
            },
            {
              value: 0,
              date: '2025-01-31',
              secondValue: 13,
            },
            {
              value: 0,
              date: '2025-03-02',
              secondValue: 138,
            },
            {
              value: 0,
              date: '2025-04-01',
              secondValue: 8,
            },
            {
              value: 0,
              date: '2025-05-01',
              secondValue: 10,
            },
            {
              value: 0,
              date: '2025-05-31',
              secondValue: 53,
            },
            {
              value: 0,
              date: '2025-06-30',
              secondValue: 18,
            },
            {
              value: 0,
              date: '2025-07-30',
              secondValue: 7,
            },
            {
              value: 0,
              date: '2025-08-29',
              secondValue: 8,
            },
            {
              value: 0,
              date: '2025-09-28',
              secondValue: 15,
            },
          ],
          gridData: [
            [
              {
                value: 0,
                date: '2025-01-01',
              },
              {
                value: 0,
                date: '2025-01-31',
              },
              {
                value: 0,
                date: '2025-03-02',
              },
              {
                value: 0,
                date: '2025-04-01',
              },
              {
                value: 0,
                date: '2025-05-01',
              },
              {
                value: 0,
                date: '2025-05-31',
              },
              {
                value: 0,
                date: '2025-06-30',
              },
              {
                value: 0,
                date: '2025-07-30',
              },
              {
                value: 0,
                date: '2025-08-29',
              },
              {
                value: 0,
                date: '2025-09-28',
              },
            ],
            [
              {
                value: 677,
                date: '2025-01-01',
              },
              {
                value: 13,
                date: '2025-01-31',
              },
              {
                value: 138,
                date: '2025-03-02',
              },
              {
                value: 8,
                date: '2025-04-01',
              },
              {
                value: 10,
                date: '2025-05-01',
              },
              {
                value: 53,
                date: '2025-05-31',
              },
              {
                value: 18,
                date: '2025-06-30',
              },
              {
                value: 7,
                date: '2025-07-30',
              },
              {
                value: 8,
                date: '2025-08-29',
              },
              {
                value: 15,
                date: '2025-09-28',
              },
            ],
          ],
        },
      },
      {
        key: 'viral',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 0,
              date: '2025-01-01',
            },
            {
              value: 0,
              date: '2025-01-31',
            },
            {
              value: 0,
              date: '2025-03-02',
            },
            {
              value: 0,
              date: '2025-04-01',
            },
            {
              value: 0,
              date: '2025-05-01',
            },
            {
              value: 0,
              date: '2025-05-31',
            },
            {
              value: 0,
              date: '2025-06-30',
            },
            {
              value: 0,
              date: '2025-07-30',
            },
            {
              value: 0,
              date: '2025-08-29',
            },
            {
              value: 0,
              date: '2025-09-28',
            },
          ],
          gridData: [
            [
              {
                value: 0,
                date: '2025-01-01',
              },
              {
                value: 0,
                date: '2025-01-31',
              },
              {
                value: 0,
                date: '2025-03-02',
              },
              {
                value: 0,
                date: '2025-04-01',
              },
              {
                value: 0,
                date: '2025-05-01',
              },
              {
                value: 0,
                date: '2025-05-31',
              },
              {
                value: 0,
                date: '2025-06-30',
              },
              {
                value: 0,
                date: '2025-07-30',
              },
              {
                value: 0,
                date: '2025-08-29',
              },
              {
                value: 0,
                date: '2025-09-28',
              },
            ],
          ],
        },
      },
      {
        key: 'nonviral',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 677,
              date: '2025-01-01',
            },
            {
              value: 13,
              date: '2025-01-31',
            },
            {
              value: 138,
              date: '2025-03-02',
            },
            {
              value: 8,
              date: '2025-04-01',
            },
            {
              value: 10,
              date: '2025-05-01',
            },
            {
              value: 53,
              date: '2025-05-31',
            },
            {
              value: 18,
              date: '2025-06-30',
            },
            {
              value: 7,
              date: '2025-07-30',
            },
            {
              value: 8,
              date: '2025-08-29',
            },
            {
              value: 15,
              date: '2025-09-28',
            },
          ],
          gridData: [
            [
              {
                value: 677,
                date: '2025-01-01',
              },
              {
                value: 13,
                date: '2025-01-31',
              },
              {
                value: 138,
                date: '2025-03-02',
              },
              {
                value: 8,
                date: '2025-04-01',
              },
              {
                value: 10,
                date: '2025-05-01',
              },
              {
                value: 53,
                date: '2025-05-31',
              },
              {
                value: 18,
                date: '2025-06-30',
              },
              {
                value: 7,
                date: '2025-07-30',
              },
              {
                value: 8,
                date: '2025-08-29',
              },
              {
                value: 15,
                date: '2025-09-28',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '947',
        metricKey: 'total',
        label: 'Total',
      },
      {
        value: '3.2',
        metricKey: 'daily_average',
        label: 'Daily average',
      },
      {
        value: '0',
        metricKey: 'viral',
        label: 'Viral unique',
      },
      {
        value: '947',
        metricKey: 'nonviral',
        label: 'Nonviral unique',
      },
    ],
    isCombinedMetric: true,
  },
};

export const VIRAL_VS_NON_VIRAL_UNIQUE = {
  metric: {
    key: 'viral_vs_nonviral_unique',
    title: 'pagePerformance.metricProperties.fb.viralUniqueVsNonviralUnique',
    queryParameter: 'viral_vs_nonviral_unique',
  },
  metricData: {
    metricCardProperties: {
      graphType: 'area',
      alternativeGraphType: 'bar',
      generalDataLabels: {
        total: 'Total',
        daily_average: 'Daily average',
        viral: 'Viral unique',
        nonviral: 'Nonviral unique',
      },
    },
    metricGraphData: [
      {
        key: 'viral_vs_nonviral',
        label: '',
        legendLabels: ['viral', 'nonviral'],
        graphValues: {
          data: [
            {
              value: 7,
              date: '2024-01-01',
              secondValue: 18,
            },
            {
              value: 2,
              date: '2024-01-31',
              secondValue: 26,
            },
            {
              value: 0,
              date: '2024-03-01',
              secondValue: 18,
            },
            {
              value: 5,
              date: '2024-03-31',
              secondValue: 16,
            },
            {
              value: 2,
              date: '2024-04-30',
              secondValue: 159,
            },
            {
              value: 1,
              date: '2024-05-30',
              secondValue: 102,
            },
            {
              value: 1,
              date: '2024-06-29',
              secondValue: 1268,
            },
            {
              value: 0,
              date: '2024-07-29',
              secondValue: 362,
            },
            {
              value: 0,
              date: '2024-08-28',
              secondValue: 28,
            },
            {
              value: 72,
              date: '2024-09-27',
              secondValue: 36,
            },
            {
              value: 1,
              date: '2024-10-27',
              secondValue: 48,
            },
            {
              value: 0,
              date: '2024-11-26',
              secondValue: 78,
            },
            {
              value: 0,
              date: '2024-12-26',
              secondValue: 3,
            },
          ],
          gridData: [
            [
              {
                value: 7,
                date: '2024-01-01',
              },
              {
                value: 2,
                date: '2024-01-31',
              },
              {
                value: 0,
                date: '2024-03-01',
              },
              {
                value: 5,
                date: '2024-03-31',
              },
              {
                value: 2,
                date: '2024-04-30',
              },
              {
                value: 1,
                date: '2024-05-30',
              },
              {
                value: 1,
                date: '2024-06-29',
              },
              {
                value: 0,
                date: '2024-07-29',
              },
              {
                value: 0,
                date: '2024-08-28',
              },
              {
                value: 72,
                date: '2024-09-27',
              },
              {
                value: 1,
                date: '2024-10-27',
              },
              {
                value: 0,
                date: '2024-11-26',
              },
              {
                value: 0,
                date: '2024-12-26',
              },
            ],
            [
              {
                value: 18,
                date: '2024-01-01',
              },
              {
                value: 26,
                date: '2024-01-31',
              },
              {
                value: 18,
                date: '2024-03-01',
              },
              {
                value: 16,
                date: '2024-03-31',
              },
              {
                value: 159,
                date: '2024-04-30',
              },
              {
                value: 102,
                date: '2024-05-30',
              },
              {
                value: 1268,
                date: '2024-06-29',
              },
              {
                value: 362,
                date: '2024-07-29',
              },
              {
                value: 28,
                date: '2024-08-28',
              },
              {
                value: 36,
                date: '2024-09-27',
              },
              {
                value: 48,
                date: '2024-10-27',
              },
              {
                value: 78,
                date: '2024-11-26',
              },
              {
                value: 3,
                date: '2024-12-26',
              },
            ],
          ],
        },
      },
      {
        key: 'viral',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 7,
              date: '2024-01-01',
            },
            {
              value: 2,
              date: '2024-01-31',
            },
            {
              value: 0,
              date: '2024-03-01',
            },
            {
              value: 5,
              date: '2024-03-31',
            },
            {
              value: 2,
              date: '2024-04-30',
            },
            {
              value: 1,
              date: '2024-05-30',
            },
            {
              value: 1,
              date: '2024-06-29',
            },
            {
              value: 0,
              date: '2024-07-29',
            },
            {
              value: 0,
              date: '2024-08-28',
            },
            {
              value: 72,
              date: '2024-09-27',
            },
            {
              value: 1,
              date: '2024-10-27',
            },
            {
              value: 0,
              date: '2024-11-26',
            },
            {
              value: 0,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 7,
                date: '2024-01-01',
              },
              {
                value: 2,
                date: '2024-01-31',
              },
              {
                value: 0,
                date: '2024-03-01',
              },
              {
                value: 5,
                date: '2024-03-31',
              },
              {
                value: 2,
                date: '2024-04-30',
              },
              {
                value: 1,
                date: '2024-05-30',
              },
              {
                value: 1,
                date: '2024-06-29',
              },
              {
                value: 0,
                date: '2024-07-29',
              },
              {
                value: 0,
                date: '2024-08-28',
              },
              {
                value: 72,
                date: '2024-09-27',
              },
              {
                value: 1,
                date: '2024-10-27',
              },
              {
                value: 0,
                date: '2024-11-26',
              },
              {
                value: 0,
                date: '2024-12-26',
              },
            ],
          ],
        },
      },
      {
        key: 'nonviral',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 18,
              date: '2024-01-01',
            },
            {
              value: 26,
              date: '2024-01-31',
            },
            {
              value: 18,
              date: '2024-03-01',
            },
            {
              value: 16,
              date: '2024-03-31',
            },
            {
              value: 159,
              date: '2024-04-30',
            },
            {
              value: 102,
              date: '2024-05-30',
            },
            {
              value: 1268,
              date: '2024-06-29',
            },
            {
              value: 362,
              date: '2024-07-29',
            },
            {
              value: 28,
              date: '2024-08-28',
            },
            {
              value: 36,
              date: '2024-09-27',
            },
            {
              value: 48,
              date: '2024-10-27',
            },
            {
              value: 78,
              date: '2024-11-26',
            },
            {
              value: 3,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 18,
                date: '2024-01-01',
              },
              {
                value: 26,
                date: '2024-01-31',
              },
              {
                value: 18,
                date: '2024-03-01',
              },
              {
                value: 16,
                date: '2024-03-31',
              },
              {
                value: 159,
                date: '2024-04-30',
              },
              {
                value: 102,
                date: '2024-05-30',
              },
              {
                value: 1268,
                date: '2024-06-29',
              },
              {
                value: 362,
                date: '2024-07-29',
              },
              {
                value: 28,
                date: '2024-08-28',
              },
              {
                value: 36,
                date: '2024-09-27',
              },
              {
                value: 48,
                date: '2024-10-27',
              },
              {
                value: 78,
                date: '2024-11-26',
              },
              {
                value: 3,
                date: '2024-12-26',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '2.25K',
        metricKey: 'total',
        label: 'Total',
      },
      {
        value: '6.16',
        metricKey: 'daily_average',
        label: 'Daily average',
      },
      {
        value: '91',
        metricKey: 'viral',
        label: 'Viral unique',
      },
      {
        value: '2.16K',
        metricKey: 'nonviral',
        label: 'Nonviral unique',
      },
    ],
    isCombinedMetric: true,
  },
};

export const PAID_ORGANIC = {
  metric: {
    key: 'paid_vs_organic',
    title: 'pagePerformance.metricProperties.fb.paidVsOrganic',
    queryParameter: 'paid_vs_organic',
  },
  metricData: {
    metricCardProperties: {
      graphType: 'area',
      generalDataLabels: {
        total: 'Total',
        daily_average: 'Daily average',
        paid: 'Paid',
        organic: 'Organic',
      },
    },
    metricGraphData: [
      {
        key: 'paid_vs_organic',
        label: '',
        legendLabels: ['paid', 'organic'],
        graphValues: {
          data: [
            {
              value: 0,
              date: '2024-01-01',
              secondValue: 34,
            },
            {
              value: 0,
              date: '2024-01-31',
              secondValue: 58,
            },
            {
              value: 0,
              date: '2024-03-01',
              secondValue: 29,
            },
            {
              value: 0,
              date: '2024-03-31',
              secondValue: 62,
            },
            {
              value: 0,
              date: '2024-04-30',
              secondValue: 191,
            },
            {
              value: 0,
              date: '2024-05-30',
              secondValue: 154,
            },
            {
              value: 0,
              date: '2024-06-29',
              secondValue: 1450,
            },
            {
              value: 0,
              date: '2024-07-29',
              secondValue: 423,
            },
            {
              value: 0,
              date: '2024-08-28',
            },
            {
              value: 0,
              date: '2024-09-27',
            },
            {
              value: 0,
              date: '2024-10-27',
            },
            {
              value: 0,
              date: '2024-11-26',
            },
            {
              value: 0,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 0,
                date: '2024-01-01',
              },
              {
                value: 0,
                date: '2024-01-31',
              },
              {
                value: 0,
                date: '2024-03-01',
              },
              {
                value: 0,
                date: '2024-03-31',
              },
              {
                value: 0,
                date: '2024-04-30',
              },
              {
                value: 0,
                date: '2024-05-30',
              },
              {
                value: 0,
                date: '2024-06-29',
              },
              {
                value: 0,
                date: '2024-07-29',
              },
              {
                value: 0,
                date: '2024-08-28',
              },
              {
                value: 0,
                date: '2024-09-27',
              },
              {
                value: 0,
                date: '2024-10-27',
              },
              {
                value: 0,
                date: '2024-11-26',
              },
              {
                value: 0,
                date: '2024-12-26',
              },
            ],
            [
              {
                value: 34,
                date: '2024-01-01',
              },
              {
                value: 58,
                date: '2024-01-31',
              },
              {
                value: 29,
                date: '2024-03-01',
              },
              {
                value: 62,
                date: '2024-03-31',
              },
              {
                value: 191,
                date: '2024-04-30',
              },
              {
                value: 154,
                date: '2024-05-30',
              },
              {
                value: 1450,
                date: '2024-06-29',
              },
              {
                value: 423,
                date: '2024-07-29',
              },
            ],
          ],
        },
      },
      {
        key: 'paid',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 0,
              date: '2024-01-01',
            },
            {
              value: 0,
              date: '2024-01-31',
            },
            {
              value: 0,
              date: '2024-03-01',
            },
            {
              value: 0,
              date: '2024-03-31',
            },
            {
              value: 0,
              date: '2024-04-30',
            },
            {
              value: 0,
              date: '2024-05-30',
            },
            {
              value: 0,
              date: '2024-06-29',
            },
            {
              value: 0,
              date: '2024-07-29',
            },
            {
              value: 0,
              date: '2024-08-28',
            },
            {
              value: 0,
              date: '2024-09-27',
            },
            {
              value: 0,
              date: '2024-10-27',
            },
            {
              value: 0,
              date: '2024-11-26',
            },
            {
              value: 0,
              date: '2024-12-26',
            },
          ],
          gridData: [
            [
              {
                value: 0,
                date: '2024-01-01',
              },
              {
                value: 0,
                date: '2024-01-31',
              },
              {
                value: 0,
                date: '2024-03-01',
              },
              {
                value: 0,
                date: '2024-03-31',
              },
              {
                value: 0,
                date: '2024-04-30',
              },
              {
                value: 0,
                date: '2024-05-30',
              },
              {
                value: 0,
                date: '2024-06-29',
              },
              {
                value: 0,
                date: '2024-07-29',
              },
              {
                value: 0,
                date: '2024-08-28',
              },
              {
                value: 0,
                date: '2024-09-27',
              },
              {
                value: 0,
                date: '2024-10-27',
              },
              {
                value: 0,
                date: '2024-11-26',
              },
              {
                value: 0,
                date: '2024-12-26',
              },
            ],
          ],
        },
      },
      {
        key: 'organic',
        label: '',
        legendLabels: [''],
        graphValues: {
          data: [
            {
              value: 34,
              date: '2024-01-01',
            },
            {
              value: 58,
              date: '2024-01-31',
            },
            {
              value: 29,
              date: '2024-03-01',
            },
            {
              value: 62,
              date: '2024-03-31',
            },
            {
              value: 191,
              date: '2024-04-30',
            },
            {
              value: 154,
              date: '2024-05-30',
            },
            {
              value: 1450,
              date: '2024-06-29',
            },
            {
              value: 423,
              date: '2024-07-29',
            },
          ],
          gridData: [
            [
              {
                value: 34,
                date: '2024-01-01',
              },
              {
                value: 58,
                date: '2024-01-31',
              },
              {
                value: 29,
                date: '2024-03-01',
              },
              {
                value: 62,
                date: '2024-03-31',
              },
              {
                value: 191,
                date: '2024-04-30',
              },
              {
                value: 154,
                date: '2024-05-30',
              },
              {
                value: 1450,
                date: '2024-06-29',
              },
              {
                value: 423,
                date: '2024-07-29',
              },
            ],
          ],
        },
      },
    ],
    metricTableData: {},
    generalData: [
      {
        value: '2.4K',
        metricKey: 'total',
        label: 'Total',
      },
      {
        value: '10',
        metricKey: 'daily_average',
        label: 'Daily average',
      },
      {
        value: '0',
        metricKey: 'paid',
        label: 'Paid',
      },
      {
        value: '2.4K',
        metricKey: 'organic',
        label: 'Organic',
      },
    ],
    isCombinedMetric: true,
  },
};
